/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { ServiceOrderListResponse } from '../types/ServiceOrderList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type ServiceOrdersRetrieveRequest = {} | null | undefined;
export type ServiceOrdersRetrieveResponse = ServiceOrderListResponse;

export type ServiceOrdersRetrieveQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this service order.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * GET /dmx-server/service_orders/{id}/
 *
 * ```yaml
 * operationId: service_orders_retrieve
 * tags:
 *   - service_orders
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ServiceOrderList'
 *     description: ''
 * ```
 */
export const serviceOrdersRetrieveOperation = ({ id, ...rest }: ServiceOrdersRetrieveQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/service_orders/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/service_orders/{id}/' };
  };

/**
 * GET /dmx-server/service_orders/{id}/
 *
 * ```yaml
 * operationId: service_orders_retrieve
 * tags:
 *   - service_orders
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ServiceOrderList'
 *     description: ''
 * ```
 */
export const serviceOrdersRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: ServiceOrdersRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<ServiceOrderListResponse>> => {
  const operation = serviceOrdersRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/service_orders/{id}/
 */
export const useServiceOrdersRetrieveResource = (
  query: ServiceOrdersRetrieveQuery | null,
  useCached?: boolean,
): UseResource<ServiceOrdersRetrieveResponse> => {
  return useResource<ServiceOrdersRetrieveResponse>({
    path: query === null ? null : serviceOrdersRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
